import { matchConsolidationDetailRoutePath, matchOrgDetailPath } from '@futrli/shared-services';

/**
 * Extracts workspaceId, organisationId, and isConsolidation from the current URL path.
 * Use this instead of useParams() in components rendered above the route context
 * (e.g. sidebars in SidebarContextProvider).
 */
export const useRouteIds = () => {
  const match =
    matchOrgDetailPath(window.location.pathname, false) || matchConsolidationDetailRoutePath(window.location.pathname);
  const workspaceId = match?.params?.workspaceId || '';
  const organisationId = match?.params?.organisationId || '';
  const isConsolidation = !!matchConsolidationDetailRoutePath(window.location.pathname);

  return { workspaceId, organisationId, isConsolidation };
};
